import easing from 'jquery.easing';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';

export class App {
  constructor(){
    this.html = document.documentElement;
    this.body = document.body;
    this.page = document.getElementById('site');
    this.ua = this.isSp(this);
    this.spd = 900;
    this.ease = "easeInOutExpo";
    this.winW = window.innerWidth;
    this.winH = window.innerHeight;
    this.header = document.getElementById('header');
    this.footer = document.querySelector('.footer');
    this.headerH = this.header.offsetHeight;
    this.gnav = this.header.querySelector('.gnav');
    this.gnav_a = this.gnav.querySelectorAll('a');

    this.btn_arr = document.getElementById('btn_arr');
    this.btn_close = document.getElementById('btn_close');
    this.btn_entries = document.querySelectorAll('.btn_entry');
    this.btn_closes = document.querySelectorAll('.btn_cls');
    this.entryContainer = document.getElementById('entryContainer');
    this.containers = document.querySelectorAll('.container_sl');
    this.btn_sls = document.querySelectorAll('.btn_sl');
    this.container_sls = document.querySelectorAll('.container_sl');

    this.ww = 768;
    this.open = false;
    this.sp = true;

    gsap.registerPlugin(ScrollTrigger)

  }
  init(){
    // console.log(this.ua)
		this.makeSp();
    this.makeParts();
    this.make_swp();
    this.resize();

    window.addEventListener('load', (e) => {
      const _this = this;
      this.page.classList.add('on');
      $('.spinner').fadeOut('slow', function(){
        $(this).remove();
        // this.addEventListener();
        _this.resize();
        _this.events();
      });
    });
  }
	makeSp(){
		this.btn_hum = document.createElement('div');
		this.btn_hum.classList.add('btn_hum')
		this.btn_hum.innerHTML = `<div class="btn_inner"><span class="bar"></span><span class="bar"></span><span class="bar"></span></div>`;
		this.header.appendChild(this.btn_hum);

    this.gback = document.createElement('div');
    this.gback.classList.add('gback');
    this.gnav.appendChild(this.gback)
	}
  makeParts(){
    this.entryb = document.createElement('div');
    this.entryb.classList.add('btn_entryb');
    this.entryContainer.appendChild(this.entryb);
    this.entryBack = document.createElement('div');
    this.entryBack.classList.add('entryBack');
    this.entryContainer.insertAdjacentElement("afterend", this.entryBack);

    this.containerBack = document.createElement('div');
    this.containerBack.classList.add('containerBack');
    document.querySelector('.sec2 .sec__inner-wrap').insertAdjacentElement('beforeend', this.containerBack);

    // console.log(this.footer);

    this.containers.forEach(
      _container => {
        const _btn = document.createElement('div');
        _btn.classList.add('btn_con_cl');
        _container.appendChild(_btn);
        _btn.addEventListener('click', (e) => {
          _container.classList.remove('on');
          this.containerBack.classList.remove('on');
        })
      }
    )
  }
  events(){
    // this.make_swp();
    
    const scT = document.querySelectorAll('.scT');
    const scTd = document.querySelectorAll('.scTd');
    const srR = document.querySelectorAll('.srR');
    const srL = document.querySelectorAll('.srL');

    scT.forEach(
      _sct => {
        gsap.fromTo(_sct, {
          y:"40px",
          opacity:0
        },{
          y:"0",
          opacity:1,
          delay:.5,
          duration:1.2,
          scrollTrigger: {
            trigger:_sct,
            start: "top bottom-=10%"
          }
        })
      }
    )
    scTd.forEach(
      _sctd => {
        gsap.fromTo(_sctd, {
          y:"40px",
          opacity:0
        },{
          y:"0",
          opacity:1,
          delay:1,
          duration:1.2,
          scrollTrigger: {
            trigger:_sctd,
            start: "top bottom-=10%"
          }
        })
      }
    )
    srR.forEach(
      _srr => {
        gsap.fromTo(_srr, {
          x:"15%",
          rotate:"30deg",
          opacity:0
        },{
          x:"0",
          rotate:"0deg",
          opacity:1,
          delay:.5,
          duration:1.2,
          scrollTrigger: {
            trigger:_srr,
            start: "top bottom-=10%"
          }
        })
      }
    )
    srL.forEach(
      _srl => {
        gsap.fromTo(_srl, {
          x:"-15%",
          rotate:"-30deg",
          opacity:0
        },{
          x:"0",
          rotate:"0deg",
          opacity:1,
          delay:.5,
          duration:1.2,
          scrollTrigger: {
            trigger:_srl,
            start: "top bottom-=20%"
          }
        })
      }
    )

    const acList = document.getElementById('acList');
    const dts = acList.querySelectorAll('.btn_ac');
    dts.forEach(
      _btn => {
        _btn.addEventListener('click', (e) => {
          const _dt = _btn.closest('dt');
          const _dd = _dt.nextElementSibling;

          if(_btn.classList.contains('on')){
            _btn.classList.remove('on')
            // _dd.style.maxHeight = "0"
						closeCh();
          }else{
            _btn.classList.add('on')
            // _dd.style.maxHeight =  _dd.querySelector('._h').offsetHeight + "px"
          }

					function closeCh(){
						const _dds = _dd.querySelectorAll('dd');
            const _btns = _dd.querySelectorAll('.btn_ac')

						setTimeout(() => {
							_dds.forEach(
              _dd => {
                _dd.style.display = 'none'
              }
            )

            _btns.forEach(
              _btn => {
                _btn.classList.remove('on')
              }
            )
						},500)

						

					}

          $(_dd).slideToggle('slow');

          if(_btn.classList.contains('_pa')){
            // console.log('pa')
            // console.log($(_dd))

            const _dds = _dd.querySelectorAll('dd');
            const _btns = _dd.querySelectorAll('.btn_ac')

            // _dds.forEach(
            //   _dd => {
            //     _dd.style.maxHeight = "0"
            //   }
            // )

            // _btns.forEach(
            //   _btn => {
            //     _btn.classList.remove('on')
            //   }
            // )
            
            
          }
          // console.log();
        })
      }
    )

    this.gnav_a.forEach(
      _btn_a => {
        _btn_a.addEventListener('click', (e) => {
          if(this.sp){
            this.menuClose();
          }
        })
      }
    )

    this.btn_hum.addEventListener('click', (e) => {
      if(this.open){
        this.menuClose();
        
      }else{
        this.menuOpen();
        
      }
    })

    this.gback.addEventListener('click', (e) => {
      this.menuClose();
    });

    window.addEventListener('resize', (e) => {this.resize();})
    const atags = document.querySelectorAll('a[href^="#"]');
    atags.forEach(
      _atag => {
        // console.log(_atag)
        _atag.addEventListener('click', (e) => {
          e.preventDefault();
          let href = e.currentTarget.getAttribute('href')
          if(href=="" || href=="#"){
            href = "top"
            this.spd = 1200
          }
          // console.log(href)
          href = href.replace("#","")
          
          const tar = document.getElementById(href)

          this.anim(tar);
        })
      }
    )

    const mediaQueryList = window.matchMedia('(min-width:'+this.ww+'px)');
    const listener = (e) => {
      if(e.matches){
        this.sp=false;
        
      }else{
        this.sp = true;
      }
      this.queryMatch();
    }
    mediaQueryList.addEventListener('change', listener);

    listener(mediaQueryList);

    this.btn_close.addEventListener('click', (e) => {
      this.entryContainer.classList.remove('on');
      this.entryBack.classList.remove('on');
    });
    this.entryb.addEventListener('click', (e) => {
      this.entryContainer.classList.remove('on');
      this.entryBack.classList.remove('on');
    });
    this.entryBack.addEventListener('click', (e) => {
      this.entryContainer.classList.remove('on');
      this.entryBack.classList.remove('on');
    });

    this.btn_entries.forEach(
      _btn => {
        _btn.addEventListener('click', (e) => {
          // console.log('entry')
          if(!this.entryContainer.classList.contains('on')){
            this.entryContainer.classList.add('on');
            this.entryBack.classList.add('on');
          }
        });
      }
    )

    this.btn_closes.forEach(
      _btnc  => {
        _btnc.addEventListener('click', (e) => {
          // console.log('close')
          if(this.entryContainer.classList.contains('on')){
            this.entryContainer.classList.remove('on')
            this.entryBack.classList.remove('on')
          }
        })
      }
    )

    this.containerBack.addEventListener('click', (e)=> {
      this.container_sls.forEach(
        _con => {
          _con.classList.remove('on');
        }
      )
      this.containerBack.classList.remove('on');
    })

    this.btn_sls.forEach(
      _btn_sl => {
        _btn_sl.addEventListener('click', (e) => {
          // this.container_sls.forEach(
          //   _con => {
          //     _con.classList.remove('on');
          //   }
          // )

          for(let i = 1; i<4; i++){
            // console.log(i)
            if(_btn_sl.classList.contains('sl'+i)){
              document.querySelector('.container_sl.sl'+i).classList.add('on')
              this.containerBack.classList.add('on');
            }
          }
          // if(_btn_sl.classList.contains('sl1')){
          //   document.querySelector('.container_sl.sl1').classList.add('on')
          // }
          // if(_btn_sl.classList.contains('sl2')){
          //   document.querySelector('.container_sl.sl2').classList.add('on')
          // }
          // if(_btn_sl.classList.contains('sl3')){
          //   document.querySelector('.container_sl.sl3').classList.add('on')
          // }
        });
      }
    )

    // this.btn_arr.addEventListener('click', (e) => {
    //   const _tar = document.getElementById('purpose');
    //   this.anim(_tar)
    // })

  }
  queryMatch(){
    // console.log(this.sp);
    if(this.sp){ //sp
      this.header.classList.add('in');
    }else{
      this.header.classList.remove('in');
      this.header.classList.remove('on');
      this.btn_hum.querySelector('.bar:nth-child(1').style.animationName=""
      this.btn_hum.querySelector('.bar:nth-child(3').style.animationName = ""
      this.open=false;
    }
  }
  menuOpen(){
    this.open = true;
    this.header.classList.add('on')
  }
  menuClose(){
    // console.log('close')
    this.open = false;
    this.header.classList.remove('on');
    this.btn_hum.querySelector('.bar:nth-child(1').style.animationName='bar1'
    this.btn_hum.querySelector('.bar:nth-child(3').style.animationName = "bar3"
  }
  make_swp(){
    // console.log('mkswp')
    const _swp_obj = {
      loop:true,
      speed: 1700,
      autoplay: {
        delay: 5000,
        disableOnInteraction:false,
        waitForTransition: false
      },
      effect:'fade',
      fadeEffect: {
        crossFade: true
      },
      on: {
        slideChange:(swiper) => {
          // console.log(swiper)
        },
        slideChangeTransitionStart: (swiper) => {
          // console.log("start="+swiper.realIndex)
          // animStart();
        },
        // slidePrevTransitionEnd: (swiper) => {
        //   console.log("prev="+swiper.realIndex)
        // },
        slideChangeTransitionEnd:(swiper) => {
          // console.log("end="+swiper.realIndex);
          // animEnd();
        }
      }
    }
    const _swp = new Swiper('.swiper', _swp_obj)
  }
  anim(_t,_tt=this.spd) {
    const rect = _t.getBoundingClientRect();
    const scT = window.pageYOffset || document.documentElement.scrollTop;
    let targetT  = rect.top;

    targetT = rect.top + scT - this.headerH;

    // console.log(scT,this.headerH);
    $('html,body').animate({
      scrollTop: targetT
    }, _tt, this.ease);
  }
  isSp(_t){
    let _ua_ar=[];
    let _ua;
    if(navigator.userAgent.match(/iPhone|iPad|iPod|Android.+Mobile/)){
      _ua_ar.push("mobile");
      _ua = "mobile";
      if(navigator.userAgent.match(/iPhone|iPod|Android.+Mobile/)){
        _ua_ar.push("m_sp");
      }
      if(navigator.userAgent.match(/iPad/)){
        // _ua_ar.push("m_pd");
      }
      // _t.makeSp();
      //console.log(_t);
      // console.log(navigator.userAgent);
    }else{
      _ua = "other";
      _ua_ar.push("other");
    }
    _ua_ar.forEach(_u => {
      _t.body.classList.add(_u);
    });
    //_t.body.classList.add(_ua_ar);
    return _ua;
  }
  resize(){
    this.getsize();
    this.html.style.setProperty('--hh', this.headerH + "px");
  }
  getsize(){
    this.winW = window.innerWidth;
    this.winH = window.innerHeight;
    this.headerH = this.header.offsetHeight;
  }
}
